import { defineStore } from 'pinia';
import { Question, Answer } from './types';

export const useAnswerStore = defineStore(
  'answers',
  {
    state: (): { answers: Answer[] } => ({
      answers: []
    }),
    actions: {
      addAnswer(question, selectedOptions) {
        return new Promise<void>(resolve => {
          const existingAnswer = this.answers.find(answer => answer.questionIdentifier === question.identifier);
          
          if (existingAnswer) {
            const existingIds = new Set(existingAnswer.selectedOptions.map(option => option.id));
            const filteredOptions = selectedOptions.filter(option => !existingIds.has(option.id));
            existingAnswer.selectedOptions = [...existingAnswer.selectedOptions, ...filteredOptions];
          } else {
            const answer = {
              question, 
              selectedOptions: selectedOptions, 
              questionIdentifier: question.identifier
            };
            this.answers.push(answer);
          }
          resolve();
        });
      },
      removeLastAnswer() {
        this.answers.pop();
      },
    },
    getters: {
      chronologicalEvaluation: (state): string => {
        return state.answers;
      },
      getAnswerByQuestionId: (state) => (questionId) => {
        return state.answers.find(answer => answer.question._id === questionId);
      }
    }
  }
);
